import React from 'react';

import { IconProps } from './types';
import styles from './../styles/icon.css';

const FilterIcon: React.FC<IconProps> = props => {
  let svgAttrs;
  if (props.fill) {
    svgAttrs = { fill: props.fill };
  } else {
    svgAttrs = { className: styles.iconSvgPath };
  }

  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.00003 4H19C19.2762 4 19.5 4.22386 19.5 4.5C19.5 4.60819 19.4649 4.71345 19.4 4.8L14 12V20.191C14 20.4671 13.7762 20.691 13.5 20.691C13.4224 20.691 13.3459 20.6729 13.2764 20.6382L10 19V12L4.60003 4.8C4.43434 4.57909 4.47912 4.26569 4.70003 4.1C4.78658 4.03509 4.89184 4 5.00003 4Z"
        {...svgAttrs}
      />
    </svg>
  );
};

export default FilterIcon;
